var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.context.Service.enabled,
          expression: "context.Service.enabled",
        },
      ],
      staticClass: "patsnap-biz-header-widget-case-time",
      attrs: { "data-lang": _vm.$i18n.locale },
    },
    [
      _c(
        "PtTooltip",
        {
          attrs: {
            effect: "dark",
            placement: "bottom",
            "visible-arrow": false,
          },
        },
        [
          _c("template", { slot: "content" }, [
            _vm.isWorking || _vm.context.Service.isPaused
              ? _c(
                  "span",
                  {
                    staticClass:
                      "patsnap-biz-header-widget-case-time_tooltip_content",
                  },
                  [
                    _vm.isWorking
                      ? [
                          _c("i", { staticClass: "case-time_working-icon" }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("case_time.rec")))]),
                        ]
                      : [
                          _c("i", { staticClass: "case-time_pause-icon" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("case_time.paused"))),
                          ]),
                        ],
                    _c("i", {
                      staticClass:
                        "patsnap-biz-header-widget-case-time_tooltip_split_line",
                    }),
                    _vm._v(" " + _vm._s(_vm.hoverLabel) + " "),
                  ],
                  2
                )
              : _c("span", [
                  _vm._v(_vm._s(_vm.$t("PtHeaderWidgetCaseTime.tooltip"))),
                ]),
          ]),
          _c("PtHeaderWidget", {
            attrs: { icon: "Timer", "data-balloon-pos": "down" },
            on: { click: _vm.handleClickTimer },
          }),
        ],
        2
      ),
      _c("CaseTime", { ref: "case" }),
      _vm.context.Service.isWorking
        ? _c("div", {
            staticClass:
              "patsnap-biz-header-widget-case-time__working-icon case-time_working-icon",
          })
        : _vm._e(),
      _vm.context.Service.isPaused
        ? _c("div", {
            staticClass:
              "patsnap-biz-header-widget-case-time__pause-icon case-time_pause-icon",
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }